/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Table_IndexInputs */

const en_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const fr_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const de_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const it_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const ru_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const es_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const zh_cn2_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const ja_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const hi_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const pt_pt2_speaker_manager_table_index = /** @type {(inputs: Speaker_Manager_Table_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

/**
* | output |
* | --- |
* | "#" |
*
* @param {Speaker_Manager_Table_IndexInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_table_index = /** @type {((inputs?: Speaker_Manager_Table_IndexInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Table_IndexInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_table_index(inputs)
	if (locale === "de") return de_speaker_manager_table_index(inputs)
	if (locale === "it") return it_speaker_manager_table_index(inputs)
	if (locale === "ru") return ru_speaker_manager_table_index(inputs)
	if (locale === "es") return es_speaker_manager_table_index(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_table_index(inputs)
	if (locale === "ja") return ja_speaker_manager_table_index(inputs)
	if (locale === "hi") return hi_speaker_manager_table_index(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_table_index(inputs)
	return en_speaker_manager_table_index(inputs)
});